var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PageLayoutForms", {
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c(
              "h1",
              {
                staticClass:
                  "pdp-mandate-onboarding-company__title typographies-heading-h1"
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t.__("pdp.mandate.Onboarding.title")) +
                    "\n        "
                )
              ]
            )
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c("CompassInformationBanner", {
              staticClass: "pdp-mandate-onboarding-company__information-banner",
              attrs: {
                title: _vm.$t.__(
                  "pdp.mandate.OnboardingCompany.InformationBanner.title"
                ),
                sourceIllustration:
                  "/ressources/logged/img/illustrations/pdp/user-identity.svg"
              },
              scopedSlots: _vm._u([
                {
                  key: "description",
                  fn: function() {
                    return [
                      _c("div", {
                        staticClass:
                          "pdp-mandate-onboarding-company__information typographies-paragraph-medium-regular",
                        domProps: {
                          innerHTML: _vm._s(_vm.informationBannerDescription)
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c(
              "h2",
              {
                staticClass:
                  "pdp-mandate-onboarding-company__subtitle typographies-heading-h2"
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t.__("pdp.mandate.OnboardingCompany.subtitle")
                    ) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pdp-mandate-onboarding-company__form-item" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "pdp-mandate-onboarding-company__company-information"
                  },
                  [
                    _c(
                      "CompassDescriptionList",
                      { attrs: { size: "small" } },
                      _vm._l(_vm.formattedCompany, function(item, index) {
                        return _c(
                          "CompassDescriptionListItem",
                          { key: index, attrs: { label: item.label } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(item.value) +
                                "\n                    "
                            )
                          ]
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pdp-mandate-onboarding-company__form-item" },
              [
                _c(
                  "CompassFormItem",
                  {
                    attrs: {
                      label: _vm.$t.__(
                        "pdp.mandate.OnboardingCompany.formItem.legal_representative"
                      ),
                      size: "large",
                      info: _vm.$t.__(
                        "pdp.mandate.OnboardingCompany.formItem.legal_representative.info"
                      )
                    }
                  },
                  [
                    _vm.isLoading
                      ? _c("CompassSkeleton", { attrs: { size: "x-large" } })
                      : _c(
                          "CompassSelect",
                          {
                            attrs: {
                              size: "large",
                              menuClass:
                                "pdp-mandate-onboarding-company__company-legal-representative"
                            },
                            model: {
                              value: _vm.selectedLegalRepresentative,
                              callback: function($$v) {
                                _vm.selectedLegalRepresentative = $$v
                              },
                              expression: "selectedLegalRepresentative"
                            }
                          },
                          _vm._l(_vm.legalRepresentatives, function(item) {
                            return _c("CompassDropdownSelectOption", {
                              key: item.name,
                              attrs: { label: item.name, value: item.name }
                            })
                          }),
                          1
                        )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "pdp-mandate-onboarding-company__help typographies-paragraph-small-semibold"
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t.__(
                              "pdp.mandate.OnboardingCompany.formItem.legal_representative.help"
                            )
                          ) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c("CompassPlainButton", {
                      attrs: {
                        label: _vm.$t.__(
                          "pdp.mandate.OnboardingCompany.support_button"
                        ),
                        size: "small"
                      },
                      on: { click: _vm.openIntercom }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c("FooterFullPage", {
              attrs: {
                primaryAction: _vm.primaryAction,
                secondaryActions: _vm.secondaryActions
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }